/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: webapp-contrib
 * Version: 7.1.2
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Gestion du drag'n'drop des cartes de page d'accueil
(function DragNDropGrid() {
    'use strict';
    var grid = null;

    // Indique si la carte peut-être déplacée
    function isDraggable(slot) {
        var isSlotDraggable = grid.classList.contains('js-slot-draggable');
        return isSlotDraggable || !(slot.classList.contains('layout__slot--empty'));
    }

    // Indique si l'échange entre 2 cartes peut être fait
    function canDoExchange(dragged, target) {
        var draggedAllows = JSON.parse(dragged.getAttribute('data-allowed-card-types'));
        var draggedType = dragged.getAttribute('data-card-type');
        var targetAllows = JSON.parse(target.getAttribute('data-allowed-card-types'));
        var targetType = target.getAttribute('data-card-type');
        return (targetAllows.indexOf(draggedType) >= 0 && (targetType === '' || draggedAllows.indexOf(targetType) >= 0));
    }

    // Indique si une carte peut être déposée dans un slot
    function canDrop(event, slot) {
        return (event.dataTransfer.types.indexOf('application/x-card') >= 0 && slot.classList.contains('layout__slot--is-target'));
    }

    // Affiche les slots qui peuvent accueillir la carte déplacée
    function displayMatchableSlots(dragged) {
        [].forEach.call(grid.querySelectorAll('.js-layout__slot'), function (target) {
            if (dragged === target) {
                return;
            }
            if (canDoExchange(dragged, target)) {
                target.classList.add('layout__slot--is-target');
            } else {
                target.classList.add('layout__slot--is-not-target');
            }
        });
    }

    // Nettoie l'interface après avoir fait un drag'n'drop
    function cleanUI() {
        [].forEach.call(grid.querySelectorAll('.js-layout__slot'), function (slot) {
            slot.classList.remove('layout__slot--is-target');
            slot.classList.remove('layout__slot--about-to-drop');
            slot.classList.remove('layout__slot--is-not-target');
        });
    }

    // Ajoute tous les événements à la page. Si le sélecteur fourni en constructeur ne correspond à aucun élément de la page, la procédure de "bind" est stoppée (évite les
    // erreurs JS inutiles).
    function init(selector) {
        grid = document.querySelector(selector);
        if (!grid) {
            return;
        }
        [].forEach.call(grid.querySelectorAll('.js-layout__slot'), function (slot) {
            cleanUI();
            slot.addEventListener('dragstart', function (event) {
                if (isDraggable(grid, slot)) {
                    event.dataTransfer.setData('application/x-card', slot.outerHTML);
                    event.dataTransfer.effectAllowed = 'move';
                    displayMatchableSlots(slot);
                } else {
                    event.preventDefault();
                }
            });
            slot.addEventListener('drop', function (event) {
                var draggedHtml = event.dataTransfer.getData('application/x-card');
                var div = document.createElement('div');
                div.innerHTML = draggedHtml;
                var dragged = div.querySelector('.js-layout__slot');
                var target = slot;
                var keyDragged = dragged.querySelector('[data-key]').getAttribute('data-key');
                var keyTarget = target.querySelector('[data-key]').getAttribute('data-key');
                jQuery(grid).data('layoutManager').switchItems(keyDragged, keyTarget);
                cleanUI();
            });
            slot.addEventListener('dragover', function (event) {
                if (canDrop(event, slot)) {
                    slot.classList.add('layout__slot--about-to-drop');
                    event.dataTransfer.dropEffect = 'move';
                    event.preventDefault();
                } else {
                    event.dataTransfer.dropEffect = 'none';
                }
            });
            slot.addEventListener('dragleave', function () {
                slot.classList.remove('layout__slot--about-to-drop');
            });
            document.addEventListener('dragend', function () {
                cleanUI();
            });
        });
    }

    init('.js-layout-manager');
})();
